/**
 * Request model for summarizing consultation actions
 * Maps to backend: ConsultationActionSummaryRequest
 */
export interface ConsultationActionSummaryRequest {
  consultationId: string;
  actionIds: string[];
}

/**
 * Factory function to create a ConsultationActionSummaryRequest
 */
export const createConsultationActionSummaryRequest = (
  consultationId: string,
  actionIds: string[] | Set<string>
): ConsultationActionSummaryRequest => {
  return {
    consultationId,
    actionIds: actionIds instanceof Set ? Array.from(actionIds) : actionIds,
  };
};
